export default {
  "nav.home": "Home",
  "nav.activities": "Activities",
  "nav.courts": "Courts",
  "nav.pricing": "Pricing",
  "nav.tournaments": "Tournaments",
  "nav.advertisers": "Advertisers",
  "nav.investors": "Investors",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.bookCourt": "Book a Court",
  "nav.downloadApp": "Download App",
  "footer.slogan": "Tennis Excellence at the Heart of Cameroon",
  "footer.quickLinks": "Quick Links",
  "footer.followUs": "Follow Us",
  "footer.mobileApp": "Mobile App",
  "footer.contact": "Contact",
  "footer.copyright": "© 2026 Tennis Club de Douala. All rights reserved.",
  "footer.legal": "Legal Notice",
  "footer.poweredBy": "Powered by Alpha Solutions",
  "footer.privacy": "Privacy Policy",
  "lang.switch": "FR",
  "lang.label": "Language",
  "hero.title": "Tennis Excellence",
  "hero.titleHighlight": "at the Heart of Cameroon",
  "hero.subtitle": "Tennis Club de Bonanjo — Douala, Cameroon",
  "hero.ctaJoin": "Join the Club",
  "hero.ctaBook": "Book a Court",
  "hero.badge1": "ITF Tournaments",
  "hero.badge2": "6 Courts",
  "hero.badge3": "Internationally Certified",
  "hero.scrollDown": "Discover",
  "numbers.courts": "Courts Available",
  "numbers.hours": "Open 7/7 — 6am to 10pm",
  "numbers.itf": "ITF J30 Tournaments Hosted",
  "numbers.coaches": "Certified Coaches",
  "numbers.sparring": "Sparring Partners",
  "numbers.school": "Kids at Tennis School",
  "vision.title": "Our Vision",
  "vision.subtitle": "President's Message",
  "vision.quote": "Our ambition is to make Tennis Club de Douala the premier tennis destination in Douala and Cameroon. We practice tennis and promote it through the discovery and development of future champions.",
  "vision.point1": "Complete club revitalization — infrastructure and positioning",
  "vision.point2": "Internationally certified coach training programs",
  "vision.point3": "Construction and renovation of ITF-standard courts",
  "vision.point4": "Padel expansion — the world's fastest-growing sport",
  "vision.point5": "International reach — tournaments and partnerships",
  "vision.cta": "Learn More",
  "courts.title": "Our Courts",
  "courts.subtitle": "World-class facilities in the heart of Douala",
  "courts.central": "Center Court",
  "courts.centralDesc": "Main court — Competitions and official matches",
  "courts.standard": "Standard Court",
  "courts.training": "Training Court",
  "courts.padel": "Coming Soon — Padel Courts",
  "courts.padelDesc": "Planned expansion — The world's fastest-growing sport arrives at TCD",
  "courts.cta": "Book a Court",
  "courts.total": "Available facilities",
  "pricing.title": "Pricing & Membership",
  "pricing.subtitle": "Plans tailored to your practice",
  "pricing.monthly": "Monthly",
  "pricing.semester": "Semester",
  "pricing.yearly": "Yearly",
  "pricing.school": "Tennis School",
  "pricing.camp": "Kid Summer Camp",
  "pricing.campPrice": "35,000 XAF",
  "pricing.perSession": "/session",
  "pricing.campFeatures": "Daily tennis · AI & tech workshops · Yoga & Pilates · Team sports · Personal development",
  "pricing.monthlyPrice": "40,000 XAF",
  "pricing.semesterPrice": "90,000 XAF",
  "pricing.yearlyPrice": "180,000 XAF",
  "pricing.schoolPrice": "60,000 XAF",
  "pricing.perMonth": "/month",
  "pricing.perYear": "/year",
  "pricing.perSemester": "/semester",
  "pricing.perQuarter": "/quarter",
  "pricing.bestOffer": "Best value",
  "pricing.monthlyFeatures": "Unlimited court access · Locker rooms · Floodlights · Priority booking · Meeting room access",
  "pricing.semesterFeatures": "All monthly + · Save 150,000 XAF · Group lessons",
  "pricing.yearlyFeatures": "All monthly + · 7.5 months free · Group lessons included",
  "pricing.schoolFeatures": "3 sessions per week · Certified coach supervision · Junior tournament participation · Training equipment · Locker room access",
  "pricing.note": "Download our mobile app to book courts. Meeting room rental available — contact us.",
  "pricing.cta": "Sign Up",
  "app.title": "Book your court in seconds",
  "app.subtitle": "Our mobile app lets you book courts, track events, and stay connected to the club wherever you are.",
  "app.feature1": "Instant booking",
  "app.feature2": "Event calendar",
  "app.feature3": "Club news",
  "app.feature4": "Real-time notifications",
  "app.googlePlay": "Get it on Google Play",
  "app.appStore": "Download on the App Store",
  "app.download": "Download the App",
  "storeModal.title": "Choose your store",
  "storeModal.subtitle": "Download the app to book your court in seconds",
  "storeModal.getItOn": "Available on Google Play Store",
  "storeModal.googlePlay": "Google Play",
  "storeModal.downloadOn": "Available on App Store",
  "storeModal.appStore": "App Store",
  "news.title": "News & Events",
  "news.subtitle": "The latest from Tennis Club de Douala",
  "news.viewAll": "View all news",
  "gallery.title": "Gallery",
  "gallery.subtitle": "Tennis Club de Douala in pictures",
  "gallery.all": "All",
  "gallery.courts": "Courts",
  "gallery.tournaments": "Tournaments",
  "gallery.coaching": "Coaching",
  "gallery.kids": "Kids",
  "gallery.events": "Events"
}